import React from 'react';
import Navbar from '../components/navbar/navbar';
import AllProducts from '../components/products/allProducts';
import Footer from '../components/footer/footer';

const Productpage = () => {
    return (
        <>

        
        
            <AllProducts />
          
        </>
    );
}

export default Productpage;
